import { Link } from 'react-router-dom';
import { getTagLabel } from '../tags';

interface TopicTagListProps {
    tags: string[];
    className?: string;
}

export default function TopicTagList({ tags, className = '' }: TopicTagListProps) {
    if (tags.length === 0) return null;

    return (
        <ul className={`flex flex-wrap gap-2 ${className}`}>
            {tags.map((tagId) => (
                <li key={tagId}>
                    <Link
                        to={`/thematic-studies?tag=${encodeURIComponent(tagId)}`}
                        onClick={(event) => event.stopPropagation()}
                        onKeyDown={(event) => event.stopPropagation()}
                        className="rounded-full bg-gray-100 px-2.5 py-1 text-xs font-medium text-default-600 transition-colors hover:bg-gray-200 dark:bg-gray-800 dark:text-default-400 dark:hover:bg-gray-700"
                    >
                        {getTagLabel(tagId)}
                    </Link>
                </li>
            ))}
        </ul>
    );
}
